import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {Contract} from '../models/contract';


export const contractActionTypes = {
  LOAD: type('[contract] Load'),
  LOAD_SUCCESS: type('[contract] Load Success'),
  LOAD_FAIL: type('[contract] Load Fail'),
  CLEAR: type('[contract] Clear'),
};

export class LoadContractAction implements Action {
  readonly type = contractActionTypes.LOAD;
  constructor(public payload?: string) {}
}

export class LoadContractSuccessAction implements Action {
  readonly type = contractActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Contract) {}
}

export class LoadContractFailAction implements Action {
  readonly type = contractActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class ContractClearAction implements Action {
  readonly type = contractActionTypes.CLEAR;
  constructor() {}
}

